import React, { useState } from "react";
import {
  LOOPS_NEWSLETTER_FORM_ENDPOINT,
  LOOPS_DEFAULT_USER_GROUP,
} from "../constants/loops";

function LoopsForm({ source = "about-page" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus("loading");
    setErrorMessage("");

    try {
      const body = new URLSearchParams();
      body.append("email", email);
      body.append("source", source);
      body.append("userGroup", LOOPS_DEFAULT_USER_GROUP);

      const response = await fetch(LOOPS_NEWSLETTER_FORM_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      if (response.ok) {
        setStatus("success");
      } else {
        let message = "Something went wrong. Please try again.";
        try {
          const data = await response.json();
          if (data?.message) message = data.message;
        } catch {
          // ignore
        }
        setErrorMessage(message);
        setStatus("error");
      }
    } catch {
      setErrorMessage("Network error. Please try again.");
      setStatus("error");
    }
  };

  return (
    <div className="mx-auto w-full max-w-md rounded bg-background p-6 text-left shadow-sm">
      {status === "success" ? (
        <div>
          <h4 className="mb-3 text-2xl font-normal text-secondary">
            Thank you!
          </h4>
          <p className="text-sm text-textSecondary">
            You have successfully joined our subscriber list.
          </p>
        </div>
      ) : (
        <>
          <h4 className="mb-2 text-2xl font-normal text-secondary">
            Join Our Community
          </h4>
          <p className="mb-4 text-sm text-textSecondary">
            Stay updated with wellness tips and special offers!
          </p>

          <form onSubmit={handleSubmit} noValidate>
            <label htmlFor="loops-form-email" className="sr-only">
              Email
            </label>
            <input
              id="loops-form-email"
              type="email"
              required
              aria-required="true"
              autoComplete="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mb-4 w-full rounded border border-tint bg-white px-3 py-2.5 text-sm text-text focus:border-primary/30 focus:ring-2 focus:ring-primary/30 focus:outline-none"
            />

            {status === "error" && errorMessage && (
              <p className="mb-3 text-xs text-red-600">{errorMessage}</p>
            )}

            <button
              type="submit"
              disabled={status === "loading"}
              className="w-full rounded bg-accent hover:bg-accentDark py-2.5 text-sm font-bold text-white transition-colors disabled:cursor-not-allowed disabled:opacity-70"
            >
              {status === "loading" ? "Subscribing..." : "Subscribe"}
            </button>

            <p className="mt-3 text-xs text-textSecondary">
              You can unsubscribe anytime. For more details, review our Privacy
              Policy.
            </p>
          </form>
        </>
      )}
    </div>
  );
}

export default LoopsForm;
